<header class="admin-header">

  <div class="search">
    <!-- <div class="search-input">
      <i class="fas fa-search"></i>
      <input type="text" placeholder="Rechercher...">
    </div> -->
  </div>
  <div class="actions">
    <div class="profile" ngbDropdown>
      <button class="profile-button" ngbDropdownToggle>
        <img [src]="user?.profile_picture || 'assets/images/avatar.jpeg'" alt="Profile">
        <span class="name">{{user?.prenom}} {{user?.name}}</span>
        <!-- <i class="fas fa-chevron-down"></i> -->
      </button>
      <div class="dropdown-menu" ngbDropdownMenu>
        <button ngbDropdownItem (click)="editProfile()">
          <i class="fas fa-user"></i> Mon profil
        </button>
        <button ngbDropdownItem (click)="openSettings()">
          <i class="fas fa-cog"></i> Paramètres
        </button>
        <div class="dropdown-divider"></div>
        <button ngbDropdownItem (click)="logout()" class="text-danger">
          <i class="fas fa-sign-out-alt"></i> Déconnexion
        </button>
      </div>
    </div>
  </div>
</header>